import numeral from "numeral";
import persianRex from "persian-rex";
import tippy from "tippy.js";
import { NumberUtils } from "../../utils/_NumberUtils";

// create bank card custom format for numeral
numeral.register("format", "bankcard", {
    regexps: {
        format: /(&)/,
        format: /(&)/,
        unformat: /(&)/,
    },
    format(value, format, roundingFunction) {
        let output;
        output = numeral._.numberToFormat(value, format, roundingFunction);

        output = output.replace(/(.{4})(?=.)/g, "$1 ");
        return output;
    },
    unformat(string) {
        return string.replace(" ", "");
    },
});

// list of regex
const regex = {
    mobile: /^(0|09|09\d{1,9})?$/,
    numeric: /^[\d]*$/,
    float: /^\d*\.?\d*$/,
    amount: /^((?:\d{1,3},?)*\d{1,3})?$/,
    zeroAmount: /^0|((?:\d{1,3},?)*\d{1,3})?$/,
    bank_card: /^((?:\d{1,4} ?){1,3}(?:\d{1,4})?)?$/,
    sheba: /^\d{0,24}$/
};

const formats = {
    amount: "[0],0",
    zeroAmount: "[0],0",
    bank_card: "0&",
};

// format and filter input on type
$.fn.inputFilter = function () {
    return this.on(
        "input",
        function (event) {
            event.stopPropagation();
            let this_value = NumberUtils.toEnNumber(this.value);
            const $this = $(this);

            // Check if fa keyboard is forbidden or not
            if (this.hasAttribute("enKeyboard")) {
                const popover = tippy(this.parentElement, {
                    content: "لطفا صفحه کلید خود را در حالت انگلیسی قرار دهید",
                    arrow: true,
                    trigger: "manual",
                    showOnCreate: false,
                    placement: "right",
                });

                if (persianRex.hasRtl.test(this_value)) {
                    popover.show();
                    setTimeout(() => {
                        popover.hide();
                    }, 1000);

                    if (
                        Object.prototype.hasOwnProperty.call(this, "oldValue")
                    ) {
                        this.value = NumberUtils.toEnNumber(this.oldValue);
                        this.setSelectionRange(
                            this.oldSelectionStart,
                            this.oldSelectionEnd
                        );
                    }
                }
            }
            const type = $this.data("type");
            if (type && regex[type]) {
                if (regex[type].test(this_value)) {
                    if (formats[type]) {
                        const formatted = numeral(this_value).format(formats[type]);
                        if (this_value === "") {
                            this_value = "";
                        } else {
                            if (formatted != 0) {
                                this_value = formatted;
                            } else {
                                if (type === "zeroAmount") {
                                    this_value = "0";
                                } else {
                                    this_value = "";
                                }
                            }
                        }
                    } else {
                        this_value = this_value;
                    }
                    this.value = this_value;
                    this.oldValue = this_value;
                    this.oldSelectionStart = this.selectionStart;
                    this.oldSelectionEnd = this.selectionEnd;
                } else if (
                    Object.prototype.hasOwnProperty.call(this, "oldValue")
                ) {
                    this.value = NumberUtils.toEnNumber(this.oldValue);
                    this.setSelectionRange(
                        this.oldSelectionStart,
                        this.oldSelectionEnd
                    );
                } else {
                    this.value = "";
                }
            }
        }
    );
};

// unformat input when get its value with jquery val() function
// and
// format input when set its value with jquery val() function
let origGetHook;
let origSetHook;

if ($.valHooks.input) {
    origGetHook = $.valHooks.input.get;
    origSetHook = $.valHooks.input.set;
} else {
    $.valHooks.input = {};
}

const getHook = function (el) {
    const $el = $(el);
    const type = $el.data("type");

    const allowHtml = $el.attr("allow-html") === 'true';
    const allowQuote = $el.attr("allow-quote") === 'true';

    const sanitizedHTML = allowHtml ? el.value : el.value.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const value = allowQuote ? sanitizedHTML : sanitizedHTML.replace(/"/g, "&quot;").replace(/'/g, "&#39;");

    if (type && formats[type]) {
        return numeral(value).value();
    }

    return value;
};

const setHook = function (el, val) {
    const $el = $(el);
    const type = $el.data("type");

    if (type && formats[type]) {
        el.value = numeral(val).format(formats[type]);
        return $el;
    }

    if (origSetHook) {
        return origSetHook(el, val);
    }

    return undefined;
};

$.valHooks.input.get = getHook;
$.valHooks.input.set = setHook;

$.valHooks.textarea = {
    get: getHook,
    set: setHook
}

$(() => {
    const rules = [
        "input[data-type=amount]",
        "input[data-type=zeroAmount]",
        "input[data-type=mobile]",
        "input[data-type=numeric]",
        "input[data-type=float]",
        "input[data-type=bank_card]",
        "input[data-type=sheba]",
        "[enKeyboard]",
    ];

    rules.forEach((rule) => {
        // const $elements = $(rule);

        // if ($elements.length > 0) {
        //     $elements.inputFilter();
        // }

        $(document).on(
            "input",
            rule,
            function (event) {
                event.stopPropagation();
                let this_value = NumberUtils.toEnNumber(this.value);
                const $this = $(this);

                // Check if fa keyboard is forbidden or not
                if (this.hasAttribute("enKeyboard")) {
                    const popover = tippy(this.parentElement, {
                        content: "لطفا صفحه کلید خود را در حالت انگلیسی قرار دهید",
                        arrow: true,
                        trigger: "manual",
                        showOnCreate: false,
                        placement: "right",
                    });

                    if (persianRex.hasRtl.test(this_value)) {
                        popover.show();
                        setTimeout(() => {
                            popover.hide();
                        }, 1000);

                        if (
                            Object.prototype.hasOwnProperty.call(this, "oldValue")
                        ) {
                            this.value = NumberUtils.toEnNumber(this.oldValue);
                            this.setSelectionRange(
                                this.oldSelectionStart,
                                this.oldSelectionEnd
                            );
                        }
                    }
                }
                const type = $this.data("type");

                if (type && regex[type]) {
                    if (regex[type].test(this_value)) {
                        // this_value = formats[type] ?
                        //     numeral(this_value).format(formats[type]) != 0 ?
                        //         numeral(this_value).format(formats[type]) :
                        //         "" :
                        //     this_value;
                        if (formats[type]) {
                            const formatted = numeral(this_value).format(formats[type]);
                            if (this_value === "") {
                                this_value = "";
                            } else {
                                if (formatted != 0) {
                                    this_value = formatted;
                                } else {
                                    if (type === "zeroAmount") {
                                        this_value = "0";
                                    } else {
                                        this_value = "";
                                    }
                                }
                            }
                        } else {
                            this_value = this_value;
                        }

                        this.value = this_value;
                        this.oldValue = this_value;
                        this.oldSelectionStart = this.selectionStart;
                        this.oldSelectionEnd = this.selectionEnd;
                    } else if (
                        Object.prototype.hasOwnProperty.call(this, "oldValue")
                    ) {
                        this.value = NumberUtils.toEnNumber(this.oldValue);
                        this.setSelectionRange(
                            this.oldSelectionStart,
                            this.oldSelectionEnd
                        );
                    } else {
                        this.value = "";
                    }
                }
            }
        );
    });
});
